import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_CENTRE_LOCATIONS,
    getCentreLocationsFail,
    getCentreLocationsSuccess
} from '../action/getCentreLocationsAction'

// api 
import getCentreLocationsApi from '../api/getCentreLocationsApi'

export function* getCentreLocationsSaga(action) {
    try {
        const response = yield call(() => getCentreLocationsApi(action.params))
        if (response.data.status === 1) {
            yield put(getCentreLocationsSuccess(response, action))
        } else {
            yield put(getCentreLocationsFail(response, action))
        }
    }
    catch (e) {
        yield put(getCentreLocationsFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_CENTRE_LOCATIONS, getCentreLocationsSaga)
}